import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { FormattedMessage, defineMessages } from 'react-intl';

import { NavLink } from 'react-router-dom';

import { connect } from 'react-redux';

import { fetchExtendedDescription, fetchServer } from 'mastodon/actions/server';
import { Account } from 'mastodon/components/account';
import { ServerHeroImage } from 'mastodon/components/server_hero_image';
import { ShortNumber } from 'mastodon/components/short_number';
import { Skeleton } from 'mastodon/components/skeleton';
import { domain } from 'mastodon/initial_state';

import { injectIntl } from './intl';

const messages = defineMessages({
  aboutActiveUsers: { id: 'server_banner.about_active_users', defaultMessage: 'People using this server during the last 30 days (Monthly Active Users)' },
  aboutThisServer: { id: 'server_banner.more_about_this_server', defaultMessage: 'More about this server'},
});

const mapStateToProps = state => ({
  server: state.server.server,
  extendedDescription: state.server.extendedDescription,
});

class ServerBanner extends PureComponent {

  static propTypes = {
    server: PropTypes.object,
    extendedDescription: PropTypes.object,
    dispatch: PropTypes.func,
    intl: PropTypes.object,
  };

  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(fetchServer());
    dispatch(fetchExtendedDescription());
  }

  render () {
    const { server, extendedDescription, intl } = this.props;
    const isLoading = server.isLoading;
    const isDescriptionLoading = isLoading || extendedDescription.isLoading;
    const extendedDescriptionContent = extendedDescription.item?.content;

    return (
      <div className='server-banner'>
        <div className='server-banner__introduction'>
          <FormattedMessage id='server_banner.is_one_of_many' defaultMessage='{domain} is one of the many independent Mastodon servers you can use to participate in the fediverse.' values={{ domain: <strong>{domain}</strong>, mastodon: <a href='https://joinmastodon.org' target='_blank' rel='noopener'>Mastodon</a> }} />
        </div>

        <NavLink to='/about'>
          <ServerHeroImage
            blurhash={server.item?.thumbnail.blurhash}
            src={server.item?.thumbnail.url}
            alt={intl.formatMessage(messages.aboutThisServer)}
            className='server-banner__hero'
          />
        </NavLink>

        <div className='server-banner__description'>
          {isDescriptionLoading ? (
            <>
              <Skeleton width='100%' />
              <br />
              <Skeleton width='100%' />
              <br />
              <Skeleton width='70%' />
            </>
          ) : (extendedDescriptionContent?.length > 0 ? (
            <div
              className='prose'
              dangerouslySetInnerHTML={{ __html: extendedDescriptionContent }}
            />
          ) : server.item?.description)}
        </div>

        <div className='server-banner__meta'>
          <div className='server-banner__meta__column'>
            <h4><FormattedMessage id='server_banner.administered_by' defaultMessage='Administered by:' /></h4>

            <Account id={server.item?.contact.account?.id} size={36} minimal />
          </div>

          <div className='server-banner__meta__column'>
            <h4><FormattedMessage id='server_banner.server_stats' defaultMessage='Server stats:' /></h4>

            {isLoading ? (
              <>
                <strong className='server-banner__number'><Skeleton width='10ch' /></strong>
                <br />
                <span className='server-banner__number-label'><Skeleton width='5ch' /></span>
              </>
            ) : (
              <>
                <strong className='server-banner__number'><ShortNumber value={server.item?.usage.users.active_month} /></strong>
                <br />
                <span className='server-banner__number-label' title={intl.formatMessage(messages.aboutActiveUsers)}><FormattedMessage id='server_banner.active_users' defaultMessage='active users' /></span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(ServerBanner));
